export const fr = {
    send: 'Envoyer',
    yes: 'Oui.',
    birthdate: 'Date de naissance',
    chooseStore: 'Choisissez votre magasin',
    city: 'Nom de la ville',
    dateFormat: 'jj-mm-aaaa',
    disclaimer: `J'accepte les <2>conditions générales</2> et la <6>politique de confidentialité</6>.`,
    email: 'Adresse e-mail',
    firstName: 'Prénom',
    houseNumber: 'Numéro de la maison (+ numéro de bus)',
    lastName: 'Nom de famille',
    lastNamePrefix: 'Infixe',
    mr: 'M.',
    mrs: 'Mme.',
    oldAddress: 'Ancienne adresse',
    newAddress: 'Nouvelle adresse',
    postService: `Utiliez-vous notre service mensuel de livraison à domicile abonnement de lentilles de contact ?`,
    phoneNumber: 'Numéro de téléphone',
    salutation: 'Salutation',
    street: 'Nom de la rue',
    zipcode: 'Code postal',
    relocationDate: 'Date du déménagement',
    requiredFootnote: 'Obligatoire',
    somethingWentWrong: "Un problème s'est produit lors de l'envoi",
    yourInfo: 'Vos données',
    yourStores: 'Dans quel(s) magasin(s) Pearle êtes-vous client ?',
    validation: {
        date: 'Saisir une date',
        dateNotValid: 'Pas de date valide',
        city: 'Saisir le nom de la ville',
        email: 'Saisir une adresse électronique',
        emailNotValid: "Pas d'adresse e-mail valide",
        firstName: 'Veuillez saisir un prénom',
        houseNumber: 'Saisir le numéro de la maison',
        lastName: 'Veuillez saisir un nom de famille',
        phone: 'Saisir un numéro de téléphone',
        phoneNotValid: 'Pas de numéro de téléphone valide',
        store: 'Choisir un magasin',
        street: 'Saisir le nom de la rue',
        yourMessage: 'Saisissez votre message',
        zipcode: 'Saisir le code postal',
    },
};
